var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTlscareLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 75,
    viewBox: "0 0 153 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_16_22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.589 62.8114V50.3431H24.7506V47.4455H37.9266V50.3431H33.0882V62.8114H29.589ZM39.8094 62.8114V47.4455H43.3086V59.9138H50.8902V62.8114H39.8094ZM57.75 63.0748C56.5404 63.0748 55.3812 62.9138 54.2724 62.5919C53.1636 62.2553 52.2708 61.8236 51.594 61.2968L52.782 58.6187C53.43 59.087 54.1932 59.4748 55.0716 59.7821C55.9644 60.0748 56.8644 60.2211 57.7716 60.2211C58.4628 60.2211 59.0172 60.1553 59.4348 60.0236C59.8668 59.8772 60.1836 59.6797 60.3852 59.4309C60.5868 59.1821 60.6876 58.8968 60.6876 58.5748C60.6876 58.1651 60.5292 57.8431 60.2124 57.609C59.8956 57.3602 59.478 57.1626 58.9596 57.0163C58.4412 56.8553 57.8652 56.709 57.2316 56.5772C56.6124 56.4309 55.986 56.2553 55.3524 56.0504C54.7332 55.8455 54.1644 55.5821 53.646 55.2602C53.1276 54.9382 52.7028 54.5138 52.3716 53.987C52.0548 53.4602 51.8964 52.787 51.8964 51.9675C51.8964 51.0894 52.1268 50.2919 52.5876 49.5748C53.0628 48.8431 53.7684 48.2651 54.7044 47.8407C55.6548 47.4016 56.8428 47.1821 58.2684 47.1821C59.2188 47.1821 60.1548 47.2992 61.0764 47.5333C61.998 47.7529 62.8116 48.0894 63.5172 48.5431L62.4372 51.2431C61.7316 50.8333 61.026 50.5333 60.3204 50.3431C59.6148 50.1382 58.9236 50.0358 58.2468 50.0358C57.57 50.0358 57.0156 50.1163 56.5836 50.2772C56.1516 50.4382 55.842 50.6504 55.6548 50.9138C55.4676 51.1626 55.374 51.4553 55.374 51.7919C55.374 52.187 55.5324 52.509 55.8492 52.7577C56.166 52.9919 56.5836 53.1821 57.102 53.3285C57.6204 53.4748 58.1892 53.6211 58.8084 53.7675C59.442 53.9138 60.0684 54.0821 60.6876 54.2724C61.3212 54.4626 61.8972 54.7187 62.4156 55.0407C62.934 55.3626 63.3516 55.787 63.6684 56.3138C63.9996 56.8407 64.1652 57.5065 64.1652 58.3114C64.1652 59.1748 63.9276 59.9651 63.4524 60.6821C62.9772 61.3992 62.2644 61.9772 61.314 62.4163C60.378 62.8553 59.19 63.0748 57.75 63.0748Z",
    fill: "#3069A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M79.4454 62.9431C78.3078 62.9431 77.2566 62.7529 76.2918 62.3724C75.327 61.9773 74.4918 61.4285 73.7862 60.726C73.0806 60.0236 72.5262 59.1968 72.123 58.2456C71.7342 57.2943 71.5398 56.2553 71.5398 55.1285C71.5398 54.0017 71.7342 52.9626 72.123 52.0114C72.5262 51.0602 73.0806 50.2334 73.7862 49.5309C74.5062 48.8285 75.3486 48.287 76.3134 47.9065C77.2782 47.5114 78.3294 47.3138 79.467 47.3138C80.5614 47.3138 81.591 47.5041 82.5558 47.8846C83.5206 48.2504 84.3342 48.8065 84.9966 49.5529L83.9814 50.5846C83.3622 49.9407 82.6782 49.4797 81.9294 49.2017C81.1806 48.909 80.3742 48.7626 79.5102 48.7626C78.603 48.7626 77.7606 48.9236 76.983 49.2455C76.2054 49.5529 75.5286 49.9992 74.9526 50.5846C74.3766 51.1553 73.923 51.8285 73.5918 52.6041C73.275 53.3651 73.1166 54.2065 73.1166 55.1285C73.1166 56.0504 73.275 56.8992 73.5918 57.6748C73.923 58.4358 74.3766 59.109 74.9526 59.6943C75.5286 60.2651 76.2054 60.7114 76.983 61.0334C77.7606 61.3407 78.603 61.4943 79.5102 61.4943C80.3742 61.4943 81.1806 61.348 81.9294 61.0553C82.6782 60.7626 83.3622 60.2943 83.9814 59.6504L84.9966 60.6821C84.3342 61.4285 83.5206 61.9919 82.5558 62.3724C81.591 62.7529 80.5542 62.9431 79.4454 62.9431ZM95.0176 62.8114V60.2651L94.9528 59.848V55.5895C94.9528 54.609 94.6792 53.8553 94.132 53.3285C93.5992 52.8016 92.8 52.5382 91.7344 52.5382C91 52.5382 90.3016 52.6626 89.6392 52.9114C88.9768 53.1602 88.4152 53.4895 87.9544 53.8992L87.2632 52.7358C87.8392 52.2382 88.5304 51.8577 89.3368 51.5943C90.1432 51.3163 90.9928 51.1773 91.8856 51.1773C93.3544 51.1773 94.4848 51.5504 95.2768 52.2968C96.0832 53.0285 96.4864 54.148 96.4864 55.6553V62.8114H95.0176ZM91.108 62.9212C90.2584 62.9212 89.5168 62.7821 88.8832 62.5041C88.264 62.2114 87.7888 61.8163 87.4576 61.3187C87.1264 60.8065 86.9608 60.2212 86.9608 59.5626C86.9608 58.9626 87.0976 58.4212 87.3712 57.9382C87.6592 57.4407 88.12 57.0456 88.7536 56.7529C89.4016 56.4455 90.2656 56.2919 91.3456 56.2919H95.2552V57.4553H91.3888C90.2944 57.4553 89.5312 57.6529 89.0992 58.048C88.6816 58.4431 88.4728 58.9334 88.4728 59.5187C88.4728 60.1773 88.7248 60.7041 89.2288 61.0992C89.7328 61.4943 90.4384 61.6919 91.3456 61.6919C92.2096 61.6919 92.9512 61.4943 93.5704 61.0992C94.204 60.6895 94.6648 60.1041 94.9528 59.3431L95.2984 60.4187C95.0104 61.1797 94.5064 61.787 93.7864 62.2407C93.0808 62.6943 92.188 62.9212 91.108 62.9212ZM100.652 62.8114V51.287H102.121V54.426L101.97 53.8773C102.286 52.9992 102.819 52.3334 103.568 51.8797C104.317 51.4114 105.246 51.1773 106.354 51.1773V52.6919C106.297 52.6919 106.239 52.6919 106.182 52.6919C106.124 52.6773 106.066 52.6699 106.009 52.6699C104.814 52.6699 103.878 53.0431 103.201 53.7895C102.524 54.5212 102.186 55.5675 102.186 56.9285V62.8114H100.652ZM113.864 62.9212C112.683 62.9212 111.646 62.6724 110.754 62.1748C109.861 61.6626 109.162 60.9675 108.658 60.0895C108.154 59.1968 107.902 58.1797 107.902 57.0382C107.902 55.8968 108.14 54.887 108.615 54.009C109.105 53.1309 109.767 52.4431 110.602 51.9456C111.452 51.4334 112.402 51.1773 113.454 51.1773C114.519 51.1773 115.462 51.426 116.283 51.9236C117.118 52.4065 117.774 53.0943 118.249 53.987C118.724 54.8651 118.962 55.8821 118.962 57.0382C118.962 57.1114 118.954 57.1919 118.94 57.2797C118.94 57.3529 118.94 57.4334 118.94 57.5212H109.069V56.3577H118.119L117.514 56.8187C117.514 55.9846 117.334 55.2456 116.974 54.6016C116.629 53.9431 116.154 53.4309 115.549 53.0651C114.944 52.6992 114.246 52.5163 113.454 52.5163C112.676 52.5163 111.978 52.6992 111.358 53.0651C110.739 53.4309 110.257 53.9431 109.911 54.6016C109.566 55.2602 109.393 56.0138 109.393 56.8626V57.1041C109.393 57.9821 109.58 58.7577 109.954 59.4309C110.343 60.0895 110.876 60.609 111.553 60.9895C112.244 61.3553 113.029 61.5382 113.907 61.5382C114.598 61.5382 115.239 61.4138 115.83 61.1651C116.434 60.9163 116.953 60.5358 117.385 60.0236L118.249 61.0334C117.745 61.648 117.111 62.1163 116.348 62.4382C115.599 62.7602 114.771 62.9212 113.864 62.9212Z",
    fill: "#20D99A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter0_d_16_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1951 15.9091C14.0804 15.9091 16.4195 13.5349 16.4195 10.6061C16.4195 7.67729 14.0804 5.30304 11.1951 5.30304C8.30974 5.30304 5.9707 7.67729 5.9707 10.6061C5.9707 13.5349 8.30974 15.9091 11.1951 15.9091Z",
    fill: "#3069A8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    filter: "url(#filter1_d_16_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5854 15.9091C36.4707 15.9091 38.8097 13.5349 38.8097 10.6061C38.8097 7.67729 36.4707 5.30304 33.5854 5.30304C30.7 5.30304 28.361 7.67729 28.361 10.6061C28.361 13.5349 30.7 15.9091 33.5854 15.9091Z",
    fill: "#20D99A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    filter: "url(#filter2_d_16_22)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1603 24.6581C25.3718 18.7233 19.536 17.3579 16.9142 17.4267C1.83213 17.5616 -0.578155 31.0569 0.101951 37.7877C2.12595 52.559 19.7706 64.2051 28.34 68.1818C21.8762 63.8651 16.0164 57.4744 13.8945 54.8185C6.64728 44.1279 9.62343 34.8229 12.0174 31.5065C17.4869 24.0508 25.6276 29.4309 29.1073 33.1388L28.1603 25.4581V24.6581Z",
    fill: "#3069A8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    filter: "url(#filter3_d_16_22)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.09 32.1735C30.0411 32.1221 29.9912 32.0703 29.9404 32.0181L29.1073 24.3559L29.1953 24.0863C29.2056 24.109 29.2158 24.1319 29.226 24.1548C31.6671 19.2086 43.7381 13.3213 53.2073 21.4565C55.5564 23.4746 60.0325 32.4711 55.5564 42.4243C56.4615 39.0763 56.4368 31.1485 49.0973 26.2216C44.6265 24.1686 34.5661 22.4849 30.09 32.1735Z",
    fill: "#20D99A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_22",
    x: 1.9707,
    y: 1.30304,
    width: 18.4488,
    height: 18.606,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_22"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_22",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_16_22",
    x: 24.361,
    y: 1.30304,
    width: 18.4488,
    height: 18.606,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_22"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_22",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_16_22",
    x: -4,
    y: 13.4243,
    width: 37.1073,
    height: 58.7576,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_22"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_22",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_16_22",
    x: 25.1073,
    y: 13.4243,
    width: 36.361,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_22"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_22",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 75,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTlscareLogo);
export default __webpack_public_path__ + "static/media/tlscare_logo.2c550f59618fa631903583c5e4956513.svg";
export { ForwardRef as ReactComponent };